import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';
import Accordion from '@/components/molecules/accordion';
import useIsCurrentPage from '@/lib/hooks/useIsCurrentPage';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import { useParams, usePathname } from 'next/navigation';
import { useEffect } from 'react';

export type FAQSectionProps = {
  data?: any;
};
type sectionType = { question: string | undefined; answer: any };

const FAQSection = ({ data }: FAQSectionProps) => {
  const Faqs = data?.sections ? data?.sections && data?.sections[4] : data;
  const foundSection = (data?.sections ?? [])?.find((sec: any) => sec?.hasOwnProperty('section_with_nested_faqs'));

  const pathname = usePathname();
  const { locale } = useParams();
  const isProductDetailPage = useIsCurrentPage(['/p/']);
  const isRegisterPage = useIsCurrentPage(['/register/']);
  const isLoginPage = useIsCurrentPage(['/login/']);
  const isFAQsPage = useIsCurrentPage(['/faqs/']);
  const isHomePage = pathname === `/${locale}/` || pathname === `/${locale}` || pathname === `/${locale}/homepage-test/`;

  const { translate } = useTranslation();

  useEffect(() => {
    const body = document.body;
    if (isHomePage) {
   
      body.classList.add('padding-horizontal');
    } else {
     
      body.classList.remove('padding-horizontal');
    }
    return () => {
     
      body.classList.remove('padding-horizontal');
    };
  }, [isHomePage]);

  return (
    <div>
      {!!foundSection ? (
        <div
          className={`${
            isFAQsPage ? 'pb-20 pt-8 sm:pt-10 lg:px-10' :isHomePage?"pt-0 pb-8 sm:pb-10": 'py-8 sm:py-10'
          } relative mx-auto w-full  px-4 md:px-8 lg:px-0`}
          id="faq-section"
        >
          <Typography
            className={`${
              isLoginPage || isFAQsPage || isHomePage || isRegisterPage ? '!font-semibold' : '!font-medium'
            } ${isFAQsPage ? 'text-center' : 'text-left'} text-primary-black !border-b border-t-0 border-l-0 border-r-0 border-[#dce0eb] pb-1 text-2xl !leading-[2.375rem] sm:!leading-[3.5rem] lg:border-none`}
          >
            {foundSection?.section_with_nested_faqs?.faq_heading}
          </Typography>
          {foundSection?.section_with_nested_faqs?.faqs?.map((_faq: any, index: number) => {
            return (
              <div key={index} className={`w-full`}>
                <Accordion className={`mr-0 !border-b border-t-0 border-l-0 border-r-0 border-[#dce0eb]`}>
                  <Accordion.Button className="!px-0 !py-4 text-left text-24 font-medium leading-8 text-[#333]">
                    <Typography
                      as="h3"
                      className={`${
                        isLoginPage || isFAQsPage || isHomePage || isRegisterPage
                          ? 'text-[21px] !font-semibold'
                          : 'text-[1.375rem] !font-medium'
                      } !leading-[2.1rem] text-[#090909] md:!leading-[2rem]`}
                    >
                      {_faq?.title}
                    </Typography>
                  </Accordion.Button>
                  <Accordion.Panel>
                    {_faq?.accordion?.map((section: sectionType, index: number) => {
                      const isLastItem = index === _faq?.accordion?.length - 1;
                      return (
                        <Accordion
                          className={`mr-0 ${isLastItem && '!!border-b border-t-0 border-l-0 border-r-0-0'} !border-b border-t-0 border-l-0 border-r-0 border-[#dce0eb]`}
                          key={index}
                        >
                          <Accordion.Button
                            className={`${
                              isLoginPage || isFAQsPage || isHomePage || isRegisterPage
                                ? 'text-[19px]'
                                : 'text-[1.375rem]'
                            } !px-0 !py-4 text-left font-normal leading-8 text-[#333]`}
                          >
                            <Typography as="h3" className="w-full">
                              {section?.question}
                            </Typography>
                          </Accordion.Button>
                          <Accordion.Panel>
                            <Markdown>{section?.answer}</Markdown>
                          </Accordion.Panel>
                        </Accordion>
                      );
                    })}
                  </Accordion.Panel>
                </Accordion>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          id="faq-section"
          className={`relative  ${
            !isProductDetailPage
              ? 'mx-auto w-full  px-4 py-8 sm:py-10 md:px-8 lg:px-10'
              : 'left-full w-screen -translate-x-full  lg:grid lg:grid-cols-12'
          } `}
        >
          <div
            className={` ${!isProductDetailPage ? '' : 'px-10 py-8 sm:py-10 md:px-10 lg:col-span-9 lg:col-start-4'}`}
          >
            <Typography
              className={`${
                isLoginPage || isFAQsPage || isHomePage || isRegisterPage ? '!font-semibold' : '!font-medium'
              } text-primary-black !border-b border-t-0 border-l-0 border-r-0 border-[#dce0eb] pb-1 text-2xl !leading-[2.375rem] sm:!leading-[3.5rem] lg:border-none`}
            >
              {Faqs?.title?.length > 0 ? Faqs?.title : translate('product.faqs')}
            </Typography>
            {Faqs?.accordion?.map((section: sectionType, index: number) => (
              <Accordion
                className={`${!isProductDetailPage ? '' : 'md:mr-20'} !border-b border-t-0 border-l-0 border-r-0 border-[#dce0eb]`}
                key={index}
              >
                <Accordion.Button
                  className={`${
                    isLoginPage || isFAQsPage || isHomePage || isRegisterPage ? 'text-[19px]' : 'text-[1.375rem]'
                  } !px-0 !py-4 text-left font-normal leading-8 text-[#333]`}
                >
                  <Typography as="h3" className="w-full">
                    {section?.question}
                  </Typography>
                </Accordion.Button>
                <Accordion.Panel>
                  <Markdown>{section?.answer}</Markdown>
                </Accordion.Panel>
              </Accordion>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default FAQSection;
